export const accountTypesFirstMorgage = [
  "85",
  "33",
  "16",
  "05",
  "2C",
  "89",
  "6D",
  "26",
  "08",
  "19",
  "27",
  "5B",
  "25",
  "5A",
  "9A",
  "87",
];
